import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import SkiGearStoragePage from '@/v2/components/pages/public-pages/ski-gear-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/ski-gear-storage-page'

interface SkiGearStoragePageProps {}

const Page: React.FC<SkiGearStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.ski_gear_storage.title ?? ''}
        keywords={META_CONTENTS.ski_gear_storage?.keywords ?? ''}
        description={META_CONTENTS.ski_gear_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <SkiGearStoragePage />
    </>
  )
}

export default Page
